(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  const track = document.getElementById("carousel-track");
  const prevBtn = document.getElementById("carousel-prev");
  const nextBtn = document.getElementById("carousel-next");

  const itemWidth = track.children[0].offsetWidth + 20; // width + gap
  let position = 0;

  nextBtn.onclick = () => {
    const maxScroll = track.scrollWidth - track.parentElement.clientWidth;
    position = Math.min(position + itemWidth, maxScroll);
    track.style.transform = `translateX(-${position}px)`;
  };

  prevBtn.onclick = () => {
    position = Math.max(position - itemWidth, 0);
    track.style.transform = `translateX(-${position}px)`;
  };
});


  } catch(e) { console.error(e); }
})();
})();
